import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-back\"><path d=\"M640 857.6c-12.8 0-21.333-4.267-29.867-12.8L307.2 541.867c-17.067-17.067-17.067-42.667 0-59.734L610.133 179.2c17.067-17.067 42.667-17.067 59.734 0s17.066 42.667 0 59.733L396.8 512l273.067 273.067c17.066 17.066 17.066 42.666 0 59.733-8.534 8.533-17.067 12.8-29.867 12.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol